


import React, { useState, useEffect } from 'react';
import { IoIosStar } from "react-icons/io";

const Carousel = () => {
    const slides = [
        {
            id: 1, content: (
                <div className='flex flex-col justify-center items-center gap-y-8'><div className='font-bold text-xl'>Joanne P</div>
                    <div className='max-w-xl text-center text-xs sm:text-sm'>Thank you so much for your continued patience and working with us to get my family covered.</div>
                    <div className='text-center'>
                        <div className='font-bold'>Joanne P</div>
                        <div className='flex text-[#ffb900]'><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /></div>
                    </div>

                </div>
            )

        },
        {
            id: 2, content: (
                <div className='flex flex-col justify-center items-center gap-y-8'><div className='font-bold text-xl'>Mark S</div>
                    <div className='max-w-xl text-center text-xs sm:text-sm'>Thank You for all your help! I know I had a lot of questions, but this is a big decision for our company that means a lot to our employees. My agents did an OUTSTANDING job helping me work through the decision. Thanks Again!</div>
                    <div className='text-center'>
                        <div className='font-bold'>Mark S</div>
                        <div className='flex text-[#ffb900]'><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /></div>
                    </div>

                </div>
            )
        },
        {
            id: 3, content: (
                <div className='flex flex-col justify-center items-center gap-y-8'><div className='font-bold text-xl'>Larry M</div>
                    <div className='max-w-xl text-center text-xs sm:text-sm'>Because I planned ahead of time and went in-network. I received a $44,000 discount on my hospital bill. Because the total payments exceeded the amount due (after discounts), I received a refund check in the mail for $7,000.</div>
                    <div className='text-center'>
                        <div className='font-bold'>Larry M</div>
                        <div className='flex text-[#ffb900]'><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /></div>
                    </div>

                </div>
            )
        },
        {
            id: 4, content: (
                <div className='flex flex-col justify-center items-center gap-y-8'><div className='font-bold text-xl'>Stacey D</div>
                    <div className='max-w-xl text-center text-xs sm:text-sm'>Satisfied with the insurance, everything is going well, and I appreciate my agent for calling to check in on me and my family.</div>
                    <div className='text-center'>
                        <div className='font-bold'>Stacey D</div>
                        <div className='flex text-[#ffb900]'><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /></div>
                    </div>

                </div>
            )
        },
        {
            id: 5, content: (
                <div className='flex flex-col justify-center items-center gap-y-8'><div className='font-bold text-xl'>Lisa G</div>
                    <div className='max-w-xl text-center text-xs sm:text-sm'>My agent has been the most help with switching our coverage for our small business we really appreciate it.</div>
                    <div className='text-center'>
                        <div className='font-bold'>Lisa G</div>
                        <div className='flex text-[#ffb900]'><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /><IoIosStar /></div>
                    </div>

                </div>
            )
        }
    ];

    const [current, setCurrent] = useState(0);

    const previousSlide = () => {
        if (current === 0) setCurrent(slides.length - 1);
        else setCurrent(current - 1);
    };

    const nextSlide = () => {
        if (current === slides.length - 1) setCurrent(0);
        else setCurrent(current + 1);
    };

    // Function to automatically slide every 15 seconds
    useEffect(() => {
        const intervalId = setInterval(() => {
            nextSlide();
        }, 15000); // Slide every 15 seconds

        return () => clearInterval(intervalId);
    }, [current]); // Restart the interval when current slide changes

    return (
        <div className="relative flex justify-center">
            <div className='carousel w-[70%] sm:w-[89%]'>
                {slides.map((slide) => {
                    return (
                        <div key={slide.id} className='carousel-item w-full flex justify-center transition ease-out duration-40' style={{ transform: `translateX(-${current * 100}%)` }}>
                            {slide.content}
                        </div>
                    );
                })}
            </div>

            <div className="absolute top-0 h-full w-full justify-between items-center flex text-white text-3xl">
                <button className='btn btn-sm btn-circle btn-link no-underline hover:no-underline text-2xl' onClick={previousSlide}>❮</button>
                <button className='btn btn-sm btn-circle btn-link no-underline hover:no-underline text-2xl' onClick={nextSlide}>❯</button>
            </div>
        </div>
    );
}

export default Carousel;
